import { render, staticRenderFns } from "./ReassignDialog.vue?vue&type=template&id=04f29c71&scoped=true"
import script from "./ReassignDialog.vue?vue&type=script&lang=js"
export * from "./ReassignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f29c71",
  null
  
)

export default component.exports